import {
  PapiRequestSettings2FaCancel,
  PapiRequestSettings2FaConfirm,
  PapiRequestSettings2FaDisable,
  PapiRequestSettings2FaEnable,
  PapiRequestSettings2FaRecovery,
  PapiSettings2FaCancel,
  PapiSettings2FaConfirm,
  PapiSettings2FaDisable,
  PapiSettings2FaEnable,
  PapiSettings2FaRecovery,
} from '@wix/da-papi-types';
import { reduxKey } from '../../constants';
import {
  createNetworkRequestActionSet,
  createNetworkRequestActionSetWithSuppliedData,
} from '../../../networking/utils';

export const {
  submit: submitTwoFactorAuthWidgetStart,
  success: submitTwoFactorAuthWidgetStartSuccess,
  failure: submitTwoFactorAuthWidgetStartFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettings2FaEnable,
  PapiSettings2FaEnable,
  { secretUrl: string; secret: string }
>(reduxKey, 'SUBMIT_TWOFACTORAUTH_WIDGET_START', {
  successPayloadGenerator: (data: PapiSettings2FaEnable) => ({
    secretUrl: data.secretUrl,
    secret: data.secret,
  }),
});

export const {
  submit: submitTwoFactorAuthWidgetVerifyAuthenticator,
  success: submitTwoFactorAuthWidgetVerifyAuthenticatorSuccess,
  failure: submitTwoFactorAuthWidgetVerifyAuthenticatorFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettings2FaConfirm,
  PapiSettings2FaConfirm,
  { recoveryCodes: string[] }
>(reduxKey, 'SUBMIT_TWOFACTORAUTH_WIDGET_VERIFY_AUTHENTICATOR', {
  successPayloadGenerator: (data: PapiSettings2FaConfirm) => ({
    recoveryCodes: data.recoveryCodes,
  }),
});

export const {
  submit: submitTwoFactorAuthWidgetRegenerateRecoveryCodes,
  success: submitTwoFactorAuthWidgetRegenerateRecoveryCodesSuccess,
  failure: submitTwoFactorAuthWidgetRegenerateRecoveryCodesFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettings2FaRecovery,
  PapiSettings2FaRecovery,
  { recoveryCodes: string[] }
>(reduxKey, 'SUBMIT_TWOFACTORAUTH_WIDGET_REGENERATE_RECOVERY_CODES', {
  successPayloadGenerator: (data: PapiSettings2FaRecovery) => ({
    recoveryCodes: data.recoveryCodes,
  }),
});

export const {
  submit: submitTwoFactorAuthWidgetReset,
  success: submitTwoFactorAuthWidgetResetSuccess,
  failure: submitTwoFactorAuthWidgetResetFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettings2FaDisable,
  PapiSettings2FaDisable
>(reduxKey, 'SUBMIT_TWOFACTORAUTH_WIDGET_RESET');

export const {
  submit: submitTwoFactorAuthWidgetCancel,
  success: submitTwoFactorAuthWidgetCancelSuccess,
  failure: submitTwoFactorAuthWidgetCancelFailure,
} = createNetworkRequestActionSet<PapiRequestSettings2FaCancel, PapiSettings2FaCancel>(
  reduxKey,
  'SUBMIT_TWOFACTORAUTH_WIDGET_CANCEL'
);
